import {UserGroupTypes} from "@app/ir-q-app-common/types/units";
import {ApiWithBody, ApiWithQuery} from "@intuitionrobotics/thunderstorm";
import {MessageType} from "@intuitionrobotics/push-pub-sub";

export type CommonBodyReq = {
    message: string
}

export const PROJECT_IDENTITY = { // never change it!!!
    _id: 'ir-q-support',
    name: 'Support Portal',
    customKeys: ["read__unitIds", "read__userGroups", "read__userGroupTypes", "write__unitIds", "write__userGroups", "write__userGroupTypes", "appArea"]
};

export enum TabPermissions {
    PM = "PM",
    MONITORING = "Monitoring",
    ACTIVATIONS = "Activations",
    ADMIN = "Admin",
    TTS = "TTS",
    CONFIGURATION_PROPERTIES = "ConfigurationProperties",
    PII_DISPOSAL = "PIIDisposal"
}

export type PermissionUnitsAccess = {
    read: {
        unitIds?: string[],
        userGroupTypes?: UserGroupTypes[],
        userGroups?: string[]
    },
    write: {
        unitIds?: string[],
        userGroupTypes?: UserGroupTypes[],
        userGroups?: string[]
    }
}

export type PermissionLevels = {
    tabs?: TabPermissions[]
    units?: PermissionUnitsAccess
}

export type GroupPermission = {
    id: string
    name: string
    permissions: PermissionLevels
}

export type AccountIdToPermission = { [userId: string]: { permission: PermissionLevels, email: string } }

export type ApiResetPermissionForUser = ApiWithBody<'/v1/permissions/reset', { userEmail: string, accountId: string }, void>
export type ApiQueryPermissionUsers = ApiWithQuery<'/v1/permissions/list-users', AccountIdToPermission>
export type ApiQueryPermissionGroups = ApiWithQuery<'/v1/permissions/list-groups', GroupPermission[]>
export type ApiUpsertPermissionGroup = ApiWithBody<'/v1/permissions/upsert-group', { group: GroupPermission }, void>
export type ApiAssignPermissionGroupToUsers = ApiWithBody<'/v1/permissions/assign', { group: GroupPermission, users: { email: string, _id: string }[], reset?: boolean }, void>

export const PushKey_PermissionUpdate = "permission-update";
export type MessageType_PermissionUpdate = MessageType<typeof PushKey_PermissionUpdate, { userId: string }, {}>

export type AccountApi_RefreshJWT = ApiWithBody<'/v1/permissions/refresh-jwt', void, void>;
